import { render, staticRenderFns } from "./BlacklistModule.vue?vue&type=template&id=2e719d2e"
import script from "./BlacklistModule.vue?vue&type=script&lang=js"
export * from "./BlacklistModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports